import {shallowMemoize} from '@sail/utils';

import type {NavigationConfigInternal} from 'src/types';

export default function memoizeConfig<
  Fn extends (config: NavigationConfigInternal, ...args: any[]) => any,
>(fn: Fn): Fn {
  return shallowMemoize(fn);
}
